import apiFetch from '../apiFetch'

export default function (token, associatedCostId) {
  return apiFetch({ endPoint: `AssociatedCostType/${associatedCostId}`, method: 'DELETE', body: null, token: token })
}
